import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { PaginationItem } from '@shared/ui/components/Pagination/PaginationItem';
import { createItems } from '@shared/ui/components/Pagination/createItems';
import { cn } from '@shared/utils/helpers';

import { PaginationProps } from './Pagination.types';

export function Pagination({ page, pages, onChange, className }: PropsWithClassName<PaginationProps>) {
  const items = createItems(page, pages);

  return (
    <nav role="navigation" aria-label="pagination" className={cn('flex justify-center flex-wrap', className)}>
      <ul className={cn('flex flex-row items-center gap-1', className)}>
        {items.map((item, index) => (
          <PaginationItem
            key={index}
            page={item.page}
            isCurrent={item.isCurrent}
            onClick={item.page ? () => onChange(item.page) : undefined}
          >
            {item.label ?? item.page}
          </PaginationItem>
        ))}
      </ul>
    </nav>
  );
}
